import { makeHttpRequest } from "@/shared";

import { mapCalculatedRentFromServer } from "./mappers/mapCalculatedRentFromServer";
import { mapInventoryBreakingToServer } from "./mappers/mapInventoryBreakingToServer";

export const removeInventoryBreaking = async (sessionKey, data) => {
    const response = (
        await makeHttpRequest({
            url: `rent/builder/${sessionKey}/remove/broken`,
            method: "DELETE",
            data: mapInventoryBreakingToServer(data),
        })
    ).data;

    return mapCalculatedRentFromServer(response.data);
};
